import { EXCEL_STYLES } from '../constants.js';
import { findFirstAggregationColumnIndex } from '../utils/columns.js';
import { getAggregationValueById } from '../data/aggregation.js';
import { mergeCells, applyCellStyle, hexColor } from '../utils/excel-helpers.js';

export const createGroupRowWithIndents = (worksheet, row, task, flatColumns, maxNestingLevel, aggregationData, fieldHandlers, options) => {
  const indent = task.level || 0;
  const borderColor = EXCEL_STYLES.GRID_BORDER;

  for (let col = 1; col <= indent; col++) {
    const cell = row.getCell(col);
    cell.value = '';
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: task.style && task.style.background ? hexColor(task.style.background) : 'FFFFFF' } };
  }

  const firstAggregationColIndex = findFirstAggregationColumnIndex(flatColumns);

  let mergeEndCol;
  if (firstAggregationColIndex !== -1) {
    mergeEndCol = maxNestingLevel + firstAggregationColIndex;
  } else {
    mergeEndCol = maxNestingLevel + flatColumns.length;
  }

  const startCol = indent + 1;

  if (mergeEndCol > startCol) {
    mergeCells(worksheet, row.number, startCol, mergeEndCol);
  }

  const groupCell = row.getCell(startCol);
  groupCell.value = task.title || '';
  groupCell.font = {
    bold: task.style.bold,
    size: task.style.fontSize ? task.style.fontSize : 12 - Math.min(task.level, 2),
    color: task.style.color ? { argb: hexColor(task.style.color) } : { argb: EXCEL_STYLES.BLACK_TEXT },

  };
  groupCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: task.style && task.style.background ? hexColor(task.style.background) : 'FFFFFF' } };
  groupCell.alignment = { horizontal: 'left', vertical: 'middle' };
  groupCell.border = {
    top: { style: 'thin', color: { argb: borderColor } },
    bottom: { style: 'thin', color: { argb: borderColor } },
  }

  flatColumns.forEach((column, colIndex) => {
    const actualColIndex = maxNestingLevel + colIndex + 1;

    if (column.type === 'aggregation' && task.groupId) {

      const aggregationValue = getAggregationValueById(task.groupId, column.key, aggregationData);

      if (aggregationValue !== null) {
        const result = fieldHandlers.groupAggregation(aggregationValue, column, hexColor(task.style.background));
        const aggCell = row.getCell(actualColIndex);
        aggCell.value = result.value || '';
        if (result.style) applyCellStyle(aggCell, result.style);
      }
    }
    if (column.key === 'level') {
      if (options.enableLevel) {
        const cell = row.getCell(actualColIndex);
        cell.value = task.level + 1 || 0;
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.font = { bold: true, color: { argb: EXCEL_STYLES.LEVEL_TEXT } };

        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: task.style && task.style.background ? hexColor(task.style.background) : 'FFFFFF' }
        }
      }
      return;
    }
  });

  for (let col = 1; col <= maxNestingLevel + flatColumns.length; col++) {
    const cell = row.getCell(col);
    if (!cell.value && (!cell.fill || !cell.fill.fgColor)) {
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: task.style && task.style.background ? hexColor(task.style.background) : 'FFFFFF' } };
    }

    cell.border = {
      top: { style: 'thin', color: { argb: borderColor } },
      bottom: { style: 'thin', color: { argb: borderColor } },
    }

    if (col === maxNestingLevel + flatColumns.length) { // Добавляем бордер справа для крайней парвой ячейки
      cell.border = {
        top: { style: 'thin', color: { argb: borderColor } },
        bottom: { style: 'thin', color: { argb: borderColor } },
        right: { style: 'thin', color: { argb: borderColor } },
      }
    }
  }
};

export const createGroupRowWithoutIndents = (worksheet, row, task, flatColumns, aggregationData, fieldHandlers, options) => {
  const firstAggregationColIndex = findFirstAggregationColumnIndex(flatColumns);
  const borderColor = EXCEL_STYLES.GRID_BORDER;

  let mergeEndCol;
  if (firstAggregationColIndex !== -1) {
    mergeEndCol = firstAggregationColIndex;
  } else {
    mergeEndCol = flatColumns.length;
  }

  if (mergeEndCol > 1) {
    mergeCells(worksheet, row.number, 1, mergeEndCol);
  }

  const groupCell = row.getCell(1);
  groupCell.value = task.title || '';
  groupCell.font = {
    bold: task.style.bold,
    size: task.style.fontSize ? task.style.fontSize : 12 - Math.min(task.level, 2),
    color: task.style.color ? { argb: hexColor(task.style.color) } : { argb: EXCEL_STYLES.BLACK_TEXT },
  };
  
  groupCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: task.style && task.style.background ? hexColor(task.style.background) : 'FFFFFF' } };
  groupCell.alignment = { horizontal: 'left', vertical: 'middle' };
  groupCell.border = {
    top: { style: 'thin', color: { argb: borderColor } },
    bottom: { style: 'thin', color: { argb: borderColor } },
  }
  
  flatColumns.forEach((column, colIndex) => {
    const actualColIndex = colIndex + 1;
    if (column.type === 'aggregation' && task.groupId) {

      const aggregationValue = getAggregationValueById(task.groupId, column.key, aggregationData);

      if (aggregationValue !== null) {
        const result = fieldHandlers.groupAggregation(aggregationValue, column, hexColor(task.style.background));
        const aggCell = row.getCell(actualColIndex);
        aggCell.value = result.value || '';
        if (result.style) applyCellStyle(aggCell, result.style);
      }
    }
    if (column.key === 'level') {
      if (options.enableLevel) {
        const cell = row.getCell(actualColIndex);
        cell.value = task.level + 1 || 0;
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.font = { bold: true, color: { argb: EXCEL_STYLES.LEVEL_TEXT } };

        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: task.style && task.style.background ? hexColor(task.style.background) : 'FFFFFF' }
        }
      }
      return;
    }
  });

  for (let col = 1; col <= flatColumns.length; col++) {
    const cell = row.getCell(col);
    if (!cell.fill) {
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: task.style && task.style.background ? hexColor(task.style.background) : 'FFFFFF' } };
    }

    cell.border = {
      top: { style: 'thin', color: { argb: borderColor } },
      bottom: { style: 'thin', color: { argb: borderColor } },
    }

    if (col === flatColumns.length) { // Добавляем бордер справа для крайней парвой ячейки
      cell.border = {
        top: { style: 'thin', color: { argb: borderColor } },
        bottom: { style: 'thin', color: { argb: borderColor } },
        right: { style: 'thin', color: { argb: borderColor } },
      }
    }
  }
};